import {
  createApp
} from 'vue'
import App from './App.vue'
import router from './router/index.js';
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import English from 'element-plus/es/locale/lang/en'
import '@/styles/normalize.css'; // normalize.css 样式格式化
import '@/styles/index.scss'; // 全局自定义的css样式
import '@/styles/newVersionUi.scss'; // 系统新版UI
import '@/styles/override.scss'; // 系统新版UI
import {
  default as api
} from './untils/api'
import {
  ElMessage
} from 'element-plus'
import store from "./store";
// import {
//   useContextService
// } from '@/services/context';

// 引入字体样式
import "@/assets/font/font.css"
// import 'default-passive-events'
const app = createApp(App)

// useContextService(app).setup((ctx) => {
//   app.config.globalProperties.$ctx = ctx;
// });
app.config.globalProperties.$api = api
app.config.globalProperties.ElMessage = ElMessage
English.el.pagination.pagesize = `  Items/Page`
app.config.globalProperties.pagination = English.el.pagination
router.afterEach((to, from, next) => { // 切换页面时top值重置
  document.querySelector('.el-main') ? (document.querySelector('.el-main').scrollTop = 0):null
})
router.beforeEach((to, from, next) => {
  if(localStorage.getItem('token')){ //判断本地是否存在 token
    if(localStorage.getItem('fullPath')){
      router.push(localStorage.getItem('fullPath')) // 登陆成功跳指定页
      localStorage.removeItem('fullPath') // 跳转后移除
    }else{
      next();
    }
  }else {
   if(to.path === '/login'){
      next();
    }else {
      // alert('请先进行登录！')
      localStorage.setItem('fullPath',to.fullPath) // 保存目标页面，登陆后跳转
      next({
        path:'/login'
      })
    }
  }
  /*如果本地 存在 token 则 不允许直接跳转到 登录页面*/
  if(to.fullPath == "/login"){
    if(localStorage.getItem('token')){
      // alert('您已经登录了，如果想要登录其他账号，请先退出当前账号！')
      next({
        path:from.fullPath
      });
    }else {
      next();
    }
  }
});
app.directive('preventReClick', {
  mounted: (el, binding, vnode) => {
    const tagName = el.localName
    console.log(tagName, 'tagName')
    el.addEventListener('click', () => {
      if (el.style['pointer-events'] != 'none') {
        el.style['pointer-events'] = 'none'
        setTimeout(() => {
          el.style['pointer-events'] = 'all'
        }, binding.value || 2000)
      }
    })
  }
})
// 全局注册
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(ElementPlus).use(store).use(router).mount('#app')